import React, { useState } from "react";
import { TextField, useTheme, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ValidateOTPandCreateNewUser, getUserByPhone } from "../components/services/userService";
import { AppContext } from "../components/services/AppContext";
import "../styles/commonStyle.css";
import ProgressMessage from "../components/booking/common/ProgressMessage";
import { useLocation } from "react-router-dom";
import Cookies from 'js-cookie';


const ValidateOTPAndRegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();
  const phone = location.state?.phone;
  const isLogin = location.state?.isLogin;

  const [name, setName] = useState({ value: "", error: "" });
  const [otp, setOtp] = useState({ value: "", error: "" });
  const [existingUserErr, setExistingUserErr] = useState('')
  const [loading, setLoading] = useState(false)

  const handleBackBtn = () => {
    navigate("/login", { state: { phone, isLogin } });
  };

  const _onValidateOtpPressed = async () => {
    const phone = AppContext.phone;

    if (!name.value) {
      setName({ value: "", error: "Please Enter Your Name" });
      return;
    }

    if (otp.value.length < 6) {
      setOtp({ ...otp, error: "Please Enter Valid OTP" });
      return;
    }
    const existingUser = await getUserByPhone(phone)
    if (existingUser._id !== "") {
      setExistingUserErr("User Already Exists.Please Login");
      return;
    }
    setExistingUserErr('')

    const newUser = {
      name: name.value.trim(),
      phone,
      email: "NA",
      mpin: "112233",
      userBrand: "NA",
      userRating: 0,
      totalRides: 0,
      status: "ACTIVE",
    };
    setLoading(true)
    setTimeout(async () => {
      const authDetails = await ValidateOTPandCreateNewUser(phone, otp.value, newUser);
      AppContext.authDetails = authDetails;

      if (authDetails.authToken === "") {
        setOtp({ ...otp, error: "Validation failed. Please try again." });
        setLoading(false);
        return;
      }
      if (authDetails && authDetails?.userId) {
        AppContext.authDetails = authDetails;
        AppContext.loggedUserId = authDetails?.userId;
        AppContext.loggedAuthToken = authDetails.authToken;
        Cookies.set('loggedUserId', authDetails.userId, { expires: 7 });
        Cookies.set('loggedAuthToken', authDetails.authToken, { expires: 7 });

      }

      setLoading(false);
      navigate("/");
    }, 2000);

  };

  return (
    <>
      {loading && <ProgressMessage progressMessage={"Validating OTP..."} />}

      <div
        className="d-flex justify-content-center align-items-start px-2 pt-5"
        style={{
          minHeight: '100vh',
          fontFamily: `'Inter', 'Segoe UI', sans-serif`,
        }}
      >
        <div className="w-100 bg-white rounded-4 shadow-sm border px-4 py-4"
          style={{ maxWidth: '420px', }}
        >
          <h5 className="fw-bold text-center mb-2 fs-5 textSuccessGreen ">
            OTP Verification
          </h5>

          <p className="text-center text-muted mb-4"
            style={{ fontSize: "0.9rem", lineHeight: 1.5 }}
          >
            Enter your name and the OTP sent to your WhatsApp to continue.
           </p>


          <TextField
            fullWidth
            label="Your Name"
            variant="outlined"
            value={name.value}
            onChange={(e) => setName({ value: e.target.value, error: "" })}
            error={!!name.error}
            helperText={name.error}
            className="customTextField mt-1"
          />

          <TextField
            fullWidth
            label="OTP"
            placeholder="Enter Your OTP"
            variant="outlined"
            value={otp.value}
            onChange={(e) => setOtp({ value: e.target.value, error: "" })}
            error={!!otp.error}
            helperText={otp.error}
            inputProps={{ maxLength: 6 }}
            className="customTextField mt-3"
          />

          {existingUserErr && (
            <p className="text-danger mt-3 small text-center">
              {existingUserErr}
            </p>
          )}

          <div className="row mt-4">
            <div className="col-6 pe-1">
              <button
                type="button"
                className="btn w-100 fw-semibold back-button"
                onClick={handleBackBtn}

              >
                Back
        </button>
            </div>
            <div className="col-6 ps-1">
              <button
                type="button"
                className="btn w-100 fw-semibold primary-button"
                onClick={_onValidateOtpPressed}

              >
                Verify OTP
        </button>
            </div>
          </div>
        </div>
      </div>


    </>

  );
};

export default ValidateOTPAndRegisterPage;
